var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 74,
    viewBox: "0 0 71 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1434_10489)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.1569,
    cy: 35.1569,
    r: 35.1569,
    fill: "#6A9817"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.1569,
    cy: 35.1569,
    r: 33.6569,
    stroke: "white",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1434_10489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4 47.5001C27.0524 47.5001 26.7068 47.4053 26.4004 47.2171C26.1254 47.0462 25.8984 46.8082 25.7409 46.5254C25.5833 46.2423 25.5004 45.9238 25.5 45.5998V26.4001C25.5 25.741 25.8419 25.1291 26.4001 24.7832C26.6761 24.6137 26.9906 24.5171 27.3141 24.5024C27.6377 24.4878 27.9597 24.5557 28.2499 24.6996C28.2501 24.6997 28.2502 24.6998 28.2504 24.6999L47.4489 34.2991C47.7645 34.4572 48.03 34.7001 48.2155 35.0005C48.401 35.3009 48.4993 35.647 48.4993 36.0001C48.4993 36.3531 48.401 36.6992 48.2155 36.9996C48.03 37.3 47.7645 37.5429 47.4489 37.701L28.2492 47.3008C27.9846 47.4331 27.6895 47.5001 27.4 47.5001Z",
    fill: "white",
    stroke: "#416206"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1434_10489",
    x: 0,
    y: 0,
    width: 70.3125,
    height: 73.3137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.415686 0 0 0 0 0.596078 0 0 0 0 0.0901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1434_10489"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1434_10489",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1434_10489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(25 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.e0924b38276ae17bbf384e86d2385e60.svg";
export { ForwardRef as ReactComponent };